import './Message.scss';
import classNames from 'classnames';

const MessageSpan = props => {
  const { children, warning, extraClassNames, style } = props;

  return (
    <span
      className={classNames('c-message-span', extraClassNames, {
        'c-message-span--warning': warning
      })}
      style={style}
    >
      {children}
    </span>
  );
};

export default MessageSpan;
